import React from 'react';
import { SearchResults } from '~/components/SearchResults';
import { Statistics } from '~/components/Statistics';
import { ClientContext } from '~/services';

export function PatientSearch() {
    const clientContext = React.useContext(ClientContext);
    return (
        <div className="container">
            <Statistics isResultsPage />
            <SearchResults reportYear={clientContext.reportYear} />
        </div>
    );
}
